import { Callout } from '../../components/PageCallout'
import { AIConversation, AIConversationKind } from '../compose/suggest/net'
import type { SearchMode } from 'components/Composer/MediaSearchPanel'

export type ComposerContentDialogTab = 'ai-content' | 'generate' | 'search' | 'edit' | 'ideas'

export interface ComposerContentDialogState {
  open: boolean
  tab: ComposerContentDialogTab
  imageUrl?: string
  conversation?: AIConversation
  prompt?: string
  kind?: AIConversationKind
  searchMode?: SearchMode
}

export type VideoCoverDialogTab = 'video' | 'upload'

export interface VideoCoverDialogState {
  open: boolean
  tab: VideoCoverDialogTab
}

export interface AppUIState {
  callouts: Callout[]
  calloutsVersion: number
  activeCallout?: Callout
  trialPopupForceOpen: {
    handle: string | null
    isAnnual?: boolean
  }
  trainingWidgetHidden?: boolean
  composerContentDialog: ComposerContentDialogState
  videoCoverDialog: VideoCoverDialogState
}

export function initialState(): AppUIState {
  return {
    callouts: [],
    calloutsVersion: 1,
    trialPopupForceOpen: { handle: null },
    composerContentDialog: { open: false, tab: 'generate' },
    videoCoverDialog: { open: false, tab: 'video' }
  }
}
